import axios from 'axios';

class AplicacionesDataService {
  getAll() {
    return axios.get(`/api/aplicaciones`);
  }

  getSimple(){
    return axios.get(`/api/aplicaciones/search`);
  }

  get(id) {
    return axios.get(`/api/aplicaciones/${id}`);
  }

  create(data) {
    return axios.post(`/api/aplicaciones`, data);
  }

  update(id, data) {
    return axios.put(`/api/aplicaciones/${id}`, data);
  }

  delete(id) {
    return axios.delete(`/api/aplicaciones/${id}`);
  }

  deleteAll() {
    return axios.delete(`/api/aplicaciones`);
  }
}

export default new AplicacionesDataService();